import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

import { Button, DialogActions, DialogContent, Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';

import AuthUserContainer from '../../../../containers/AuthUser';
import Transition from '../../../../components/dialogs/Transition';
import FormComponent from '../../../../components/FormComponent';
import { post } from '../../../../modules/utility';
import { unloadingDelayReason } from '../delayReasons';
import { dialogStyles } from './dialogStyles';
import MobileDeliveryDialogSavePopup from './MobileDeliveryDialogSavePopup';
import MobileScannerDialog from './mobileScannerDialog/MobileScannerDialog';
import MobileImageZoomDialog from './MobileImageZoomDialog';
import MobileDeliveryRemoveConfirmationDialog from './MobileDeliveryRemoveConfirmationDialog';
import { docTypeDisplayToValue, documentTypes } from './ScannerHelper';

const styles = () => {
	return {
		...dialogStyles,
		blah: {
			fontWeight: 'bold',
			fontSize: '100%',
			//backgroundColor: stlBlue,
			//color: 'white',
			padding: `3.33vw 5.8vw`,
			lineHeight: 1,
			borderRadius: '1vw',
			//minWidth: '30vw',
		},

		documentSelectionButton: {
			fontWeight: 'bold',
			fontSize: '140%',
			//backgroundColor: stlBluer
			color: 'white',
			padding: `4.5vw 4vw`,
			lineHeight: 1,
			borderRadius: 4,
			minWidth: '38vw',
		},

		sectionTitle: {
			fontSize: '150%',
			borderBottom: '1px solid #eee',
			paddingBottom: '.5vw',
			marginBottom: '2vw',
			fontWeight: 500,
			display: 'flex',
			justifyContent: 'space-between',
		},
	};
};

class MobileDeliveryScanDocumentsDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			isScannerOpen: false,
			isZoomOpen: false,
			selectedDocumentType: undefined,
			photoResources: [],
			isRemoveConfirmOpen: false,
			scannedDocumentToRemove: undefined,
			documentIdsToRemove: [],
			newScannedDocuments: [],
		};
	}

	componentDidMount() {
		const { delays } = this.props;
		if (!delays) {
			return;
		}
		this.fillForm({ delays });
	}

	fillForm = ({ delays }) => {
		if (_.isEmpty(delays)) {
			return;
		}

		const newState = {};
		delays.forEach(({ delayReason, delayNotes, photoResources }) => {
			newState.delayNotes = delayNotes;
			if (delayReason) {
				newState[delayReason] = true;
			}
			if (!_.isEmpty(photoResources)) {
				newState.photoResources = photoResources;
			}
		});
		return this.setState(newState);
	};

	// componentDidUpdate(_prevProps, prevState, _snapshot) {
	// }

	handleSaveConsigneeDelay = () => {
		const { stopNumber, tmwOrderId } = this.props;
		const { delayNotes, photoResources } = this.state;
		const formFieldError = {};

		let delayReasons = [];
		unloadingDelayReason.forEach((unloadingDelayReason) => {
			if (this.state[unloadingDelayReason.value]) {
				delayReasons.push(unloadingDelayReason.value);
			}
		});

		if (_.isEmpty(delayReasons)) {
			formFieldError.superDuper = 'Must select a delay reason';
		} else {
			if (_.find(delayReasons, 'other') && !delayNotes) {
				formFieldError.delayNotes = 'Other requires some additional notes';
			}
		}

		if (_.keys(formFieldError).length) {
			this.setState({
				formFieldError,
				isSaving: false,
				hasSavingSuccess: false,
				hasSavingError: true,
				savingError: _.values(formFieldError).join('.'),
			});
			return;
		}

		let photoResourceIds = [];
		if (!_.isEmpty(photoResources)) {
			photoResourceIds = _.map(photoResources, 'resourceId');
		}

		this.setState({ isSaving: true });
		post({
			method: 'tmw.deliveryTicket.updateDelay',
			params: {
				tmwOrderId,
				stopNumber,
				delayType: 'consignee',
				delayReasons,
				delayNotes,
				photoResourceIds,
			},
			callback: (err, _r) => {
				if (err) {
					return this.setState({
						isSaving: false,
						hasSavingSuccess: false,
						hasSavingError: true,
						savingError: err,
					});
				}

				this.setState({
					isSaving: false,
					hasSavingSuccess: true,
					hasSavingError: false,
				});

				setTimeout(() => {
					this.setState({
						hasSavingSuccess: false,
					});
				}, 3000);
			},
		});
	};

	handleClose = () => {
		this.setState({
			isSaving: false,
			hasSavingSuccess: false,
			hasSavingError: false,
		});
		this.props.onClose();
	};

	openScanner = (documentType) => {
		this.setState({
			selectedDocumentType: documentType,
			isScannerOpen: true,
		});
	};
	closeScanner = () => {
		this.setState({
			isScannerOpen: false,
		});
	};

	setBolResource = (photoResource) => {
		const { stopNumber, tmwOrderId } = this.props;
		const { selectedDocumentType, newScannedDocuments } = this.state;
		const scannedDocumentResourceId = photoResource.resourceId;

		// Post this to the server right no
		this.setState({ isSaving: true });
		post({
			method: 'scannedDocument.add',
			params: {
				scannedDocumentResourceId,
				documentType: selectedDocumentType,
				tmwOrderId,
				stopNumber,
			},
			callback: (err, r) => {
				if (err) {
					return this.setState({
						isSaving: false,
						hasSavingSuccess: false,
						hasSavingError: true,
						savingError: err,
					});
				}

				// Lets ad the result to the list

				const docs = r.collections.scannedDocumentCollection || [];
				const resources = r.collections.resourceCollection || [];
				const resourceLookup = _.keyBy(resources, 'resourceId');

				docs.forEach((scannedDocument) => {
					const { scannedDocumentResourceId } = scannedDocument;
					const resource = resourceLookup[scannedDocumentResourceId];
					if (!resource) {
						console.error(`Scanned document missing resource`, scannedDocumentResourceId);
						return;
					}
					scannedDocument.url = resource.url;
				});

				this.setState({
					isSaving: false,
					hasSavingSuccess: true,
					hasSavingError: false,
					newScannedDocuments: newScannedDocuments.concat(docs),
				});
			},
		});

		/*
		const { photoResources } = this.state;
		photoResources.push(photoResource);
		return this.setState({
			photoResources,
		});
		*/
	};

	showZoomImageDialog = (imageSrcUrlToZoom) => {
		this.setState({ isZoomOpen: true, imageSrcUrlToZoom });
	};
	hideZoomImageDialog = () => {
		this.setState({
			imageSrcUrlToZoom: undefined,
			isZoomOpen: false,
		});
	};

	showRemoveConfirmDialog = (scannedDocumentToRemove) => {
		this.setState({
			isRemoveConfirmOpen: true,
			scannedDocumentToRemove,
		});
	};
	hideRemoveConfirmDialog = (didRemoveDocument) => {
		const { documentIdsToRemove } = this.state;
		if (didRemoveDocument) {
			const { scannedDocumentToRemove } = this.state;
			documentIdsToRemove.push(scannedDocumentToRemove.scannedDocumentId);
		}

		this.setState({
			isRemoveConfirmOpen: false,
			scannedDocumentToRemove: undefined,
			documentIdsToRemove,
		});
	};

	render() {
		const { open, classes, scannedDocuments } = this.props;
		const {
			isSaving,
			hasSavingSuccess,
			hasSavingError,
			savingError,
			newScannedDocuments,
			documentIdsToRemove,
		} = this.state;

		let allScannedDocuments = [];
		if (!_.isEmpty(scannedDocuments)) {
			allScannedDocuments = scannedDocuments;
		}

		if (!_.isEmpty(newScannedDocuments)) {
			allScannedDocuments = allScannedDocuments.concat(newScannedDocuments);
		}

		if (!_.isEmpty(documentIdsToRemove)) {
			allScannedDocuments = _.filter(allScannedDocuments, (a) => {
				return !_.includes(documentIdsToRemove, a.scannedDocumentId);
			});
		}

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				fullWidth={true}
				maxWidth={'lg'}
				classes={{
					scrollPaper: classes.dialogScroll,
					paper: classes.dialogPaper,
				}}
			>
				<DialogContent
					style={{ position: 'relative', paddingTop: '2vw' }}
					classes={{
						root: classes.dialogContent,
					}}
				>
					<div className={classes.sectionTitle}>
						<div>Add New Document</div>
					</div>

					<Grid container spacing={2}>
						{documentTypes.map((documentType) => {
							return (
								<Grid key={documentType.value} item xs={6} style={{ textAlign: 'center' }}>
									<Button
										className={classes.documentSelectionButton}
										variant="contained"
										color="primary"
										aria-label="veeder rot"
										onClick={() => this.openScanner(documentType.value)}
									>
										{documentType.display}
									</Button>
								</Grid>
							);
						})}
					</Grid>

					<div className={classes.sectionTitle} style={{ paddingTop: '6vw' }}>
						<div>Uploaded Documents</div>
					</div>
					<div className={classes.commodityFormProductInput} style={{ minHeight: '15vw' }}>
						{_.isEmpty(allScannedDocuments) && (
							<div style={{ fontSize: '150%', fontStyle: 'italic', color: '#666' }}>
								No documents uploaded yet.
							</div>
						)}

						{!_.isEmpty(allScannedDocuments) && (
							<div style={{ width: '100%' }}>
								{allScannedDocuments.map((scannedDocument) => {
									const { url, documentType, dateCreated, scannedDocumentId } = scannedDocument;
									const dateFormatted = moment(dateCreated).format('M/D h:mm a');
									return (
										<div
											key={scannedDocumentId}
											style={{
												display: 'flex',
												fontSize: '140%',
											}}
										>
											<img
												alt="scan"
												src={url}
												style={{
													height: '24vw',
													cursor: 'pointer',
													padding: '1vw',
													marginRight: '2vw',
												}}
												onClick={() => {
													this.showZoomImageDialog(url);
												}}
											/>
											<div style={{ paddingTop: 10, width: '100%' }}>
												<div style={{ fontSize: '120%', fontWeight: 'bold' }}>
													Type: {docTypeDisplayToValue[documentType]}
												</div>
												<div>Added: {dateFormatted}</div>
												<div style={{ paddingTop: 10, width: '100%', textAlign: 'right' }}>
													<Button
														variant="outlined"
														aria-label="Remove"
														onClick={() => {
															this.showRemoveConfirmDialog(scannedDocument);
														}}
													>
														Remove
													</Button>
												</div>
											</div>
										</div>
									);
								})}

								<MobileImageZoomDialog
									open={this.state.isZoomOpen}
									onClose={this.hideZoomImageDialog}
									imageSrcUrl={this.state.imageSrcUrlToZoom}
								/>

								<MobileDeliveryRemoveConfirmationDialog
									open={this.state.isRemoveConfirmOpen}
									onClose={this.hideRemoveConfirmDialog}
									scannedDocument={this.state.scannedDocumentToRemove}
								/>
							</div>
						)}
					</div>

					<MobileScannerDialog
						//classes={classes }
						open={this.state.isScannerOpen}
						onClose={this.closeScanner}
						// freightNumber={this.freightNumberForScanner}
						setBolResource={this.setBolResource}
					/>
				</DialogContent>

				<DialogActions style={{ position: 'relative', backgroundColor: '#f7f7f7' }}>
					<MobileDeliveryDialogSavePopup
						isSaving={isSaving}
						hasSavingSuccess={hasSavingSuccess}
						hasSavingError={hasSavingError}
						savingError={savingError}
						savingSuccess={'Document saved'}
					/>

					<div style={{ display: 'flex', width: '100%', padding: '0 2vw' }}>
						<Button
							variant="outlined"
							className={classes.dialogCloseButton}
							onClick={this.handleClose}
						>
							Close
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

MobileDeliveryScanDocumentsDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	classes: PropTypes.object.isRequired,
	stopNumber: PropTypes.number,
	scannedDocuments: PropTypes.array,
};

export default _.flow([withStyles(styles), AuthUserContainer])(MobileDeliveryScanDocumentsDialog);
